import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  borderBottom: {
    borderBottom: '1px solid #403849',
    marginBottom: '1rem !important',
  },
  dFlexA: {
    alignItems: 'center',
    display: 'flex',
  },
  dFlexJA: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  dateFilter: {
    '& .date-control': {
      '& .label': {
        color: '#FFFFFF',
        fontFamily: 'FiraSans-Medium',
        fontSize: '0.82rem',
        fontWeight: '500',
        textTransform: 'capitalize',
      },
      width: '49%',
    },
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  filterBtn: {
    alignItems: 'center',
    backgroundColor: '#DEC330',
    borderRadius: '4px',
    color: '#fff !important',
    cursor: 'pointer',
    display: 'flex',
    height: '48px',
    justifyContent: 'center',
    textTransform: 'uppercase',
    width: '100%',
  },
  filterIcon: {
    width: '18px',
  },
  filterLabel: {
    color: '#FFFFFF',
    fontFamily: 'FiraSans-Medium',
    fontSize: '15px',
    fontWeight: '500',
    height: '22px',
    letterSpacing: '1px',
    lineHeight: '22px',
    textTransform: 'capitalize',
  },
  inputF: {
    '& .MuiFilledInput-root': {
      color: '#FFFFFF !important',
      fontFamily: 'FiraSans-Medium !important',
    },
    '& Mui-error': {
      height: 0,
      paddingLeft: '5px',
    },
    '& input': {
      color: '#FFFFFF',
      fontFamily: 'FiraSans-Medium',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '20px',
      padding: '11px',
    },

    '&::placeholder': {
      color: '#FFFFFF',
      fontFamily: 'FiraSans-Medium',
      opacity: '0.43',
    },
    '&:focusVisible': {
      outline: 'unset !important',
    },
    background: 'unset !important',
    border: 'unset !important',
    color: '#ffff !important',
    width: '100%',
  },
  optionsClassName: {
    backgroundColor: '#241A2E !important',
    // backgroundColor: theme.palette.common.white + '!important',
    color: '#ffff !important',
    paddingLeft: '10px !important',
    paddingRight: '27px !important',
    textTransform: 'capitalize',
  },
  resetF: {
    alignItems: 'center',
    backgroundColor: 'unset !important',
    color: '#777777 !important',
    cursor: 'pointer',
    display: 'flex',
    fontFamily: 'FiraSans-Bold',
    fontSize: '12px !important',
    height: '48px !important',
    justifyContent: 'center !important',
    letterSpacing: '0.8px',
    textDecoration: 'underline solid #777777',
  },
  searchBox: {
    '& .date-picker': {
      '& .MuiInputBase-input': {
        color: '#FFFFFF !important',
      },
    },

    alignItems: 'center',
    backgroundColor: '#403849',
    borderRadius: '7px',
    color: '#FFF',
    display: 'flex',
    height: '43px',
    marginBottom: '0.5rem !important',
  },
  searchBoxHeader: {
    '& .date-picker': {
      '& .MuiInputBase-input': {
        color: '#241a2e !important',
      },
    },

    alignItems: 'center',
    backgroundColor: '#FFFFFF !important',
    borderRadius: '7px',
    color: '#241a2e !important',
    display: 'flex',
    height: '46px',
    marginBottom: '0.5rem !important',
  },
  selectClassName: {
    borderRadius: '7px !important',
    color: '#FFFFFF !important',
    fontFamily: 'FiraSans-Medium !important',
    fontSize: '14px !important',
    fontWeight: ' 500 !important',
    letterSpacing: '0 !important',
  },
  selectClassNameHeader: {
    borderRadius: '7px !important',
    color: '#241a2e !important',
    // color: '#c3c0c7 !important', // default place holder color
    fontFamily: 'FiraSans-Medium !important',
    fontSize: '14px !important',
    fontWeight: ' 500 !important',
    letterSpacing: '0 !important',
  },
  selectWhiteBg: {
    '&.MuiInputBase-colorPrimary': {
      backgroundColor: '#FFFFFF !important',
    },
    borderRadius: '7px !important',
    color: '#000000 !important',
    fontFamily: 'FiraSans-Medium !important',
    fontSize: '14px !important',
    fontWeight: ' 500 !important',
    letterSpacing: '0 !important',
  },
  submited: {
    boxShadow: 'unset',
  },
}));

export default useStyles;
